<template>
  <div class="wrapper">
    <div
      id="sadmac"
      class="modal hidden"
    >
      <img src="@/assets/img/sadmac.png">
    </div>

    <nav>
      <div class="nav-wrapper">
        <ul class="nav-list">
          <li
            class="os-logo menu-container"
          >
            <img
              src="@/assets/img/spinner.gif"
              width="14px"
            >
            <ul class="menu command_button">
              <li id="menu-about">
                <img
                  src="@/assets/img/question.png"
                  width="8"
                  height="12"
                  alt="About"
                ><span>About</span>
              </li>
            </ul>
          </li>
          <li class="menu-container">
            File
            <ul class="menu command_button">
              <li id="menu-controls">
                <img
                  src="@/assets/img/cd.png"
                  width="16"
                  alt="Cause an error"
                >
                <span>RPUNK FM</span>
              </li>
              <li id="menu-suitup">
                <img
                  src="@/assets/img/suiticon.png"
                  width="16"
                  alt="Suit Up"
                >
                <span>Suit Up</span>
              </li>
              <li id="menu-errorWindow">
                <img
                  src="@/assets/img/bomb.png"
                  width="16"
                  alt="Cause an error"
                >
                <span>Don't Push This Button</span>
              </li>
            </ul>
          </li>
          <li class="menu-container">
            Help
            <ul class="menu command_button">
              <li class="disabled">
                <img
                  src="@/assets/img/discord.png"
                  width="16"
                >
                <span>
                  <a
                    href="https://discord.gg/7YVaRwrdEt"
                    target="_blank"
                  >
                    Discord
                  </a>
                </span>
              </li>
              <li class="disabled">
                <img
                  src="@/assets/img/twitter.png"
                  width="16"
                >
                <span>
                  <a
                    href="https://twitter.com/radioactivepnks"
                    target="_blank"
                  >
                    Twitter
                  </a>
                </span>
              </li>
              <li class="disabled">
                <img
                  src="@/assets/img/opensea.png"
                  width="16"
                >
                <span>
                  <a
                    href="https://opensea.io/collection/radioactive-punks"
                    target="_blank"
                  >
                    RPUNK OpenSea
                  </a>
                </span>
              </li>
              <li class="disabled">
                <img
                  src="@/assets/img/about.png"
                  width="16"
                >
                <span>
                  <a
                    href="https://etherscan.io/address/0x073ca28e04719c05a5a48c1d992091b4075a0f84#code"
                    target="_blank"
                  >
                    RPUNK Contract
                  </a>
                </span>
              </li>
              <li class="disabled">
                <img
                  src="@/assets/img/opensea.png"
                  width="16"
                >
                <span>
                  <a
                    href="https://opensea.io/collection/radioactive-pets"
                    target="_blank"
                  >
                    RPETS OpenSea
                  </a>
                </span>
              </li>
              <li class="disabled">
                <img
                  src="@/assets/img/about.png"
                  width="16"
                >
                <span>
                  <a
                    href="https://etherscan.io/address/0x3a7E7b26f779DE6D12A675caa34419625Aa67159#code"
                    target="_blank"
                  >
                    RPETS Contract
                  </a>
                </span>
              </li>
            </ul>
          </li>
          <li
            id="macoslogo"
            class="nav-list menu-container"
            @click="toggleDisconnectMenu"
          >
            <img
              src="@/assets/wallet.png"
              alt="MacOS"
            >
            <ul
              v-if="showDisconnectMenu"
              id="wallet-menu menu command_button"
              style="position: absolute; right: 0; width: 80px;"
              class="menu"
            >
              <li v-if="walletConnected">
                {{ accountAddress.slice(0,8) }}
              </li>
              <li
                v-if="walletConnected"
                @click="logOut"
              >
                Disconnect
              </li>
              <li
                v-else
                @click="connectAccount"
              >
                Connect
              </li>
            </ul>
          </li>
          <li
            id="time"
            class="time text-center timeText"
          >
            Loading...
          </li>
        </ul>
      </div>
    </nav>

    <div
      id="boot"
      class="modal"
    >
      <div
        class="command_button boot-button close-button"
        id="boot-button"
      >
        <video
          src="@/assets/boom.mp4"
          muted
          autoplay
          loop
        />
        <div
          class="bottom-booter"
        >
          <h2>
            RADIOACTIVE PUNKS OS
          </h2>
          <p style="text-align: center; margin-bottom: 15px;">
            <span class="rainbow-text">Positive Vibrations Only Labs™</span>
          </p>
          <button
            @click="bootUp"
            style="font-size: 12px;"
          >
            BOOT
          </button>
        </div>
      </div>
    </div>

    <WalletPicker
      v-if="walletChoices.length"
      :connectors="walletChoices"
      @select="onWalletChosen"
      @cancel="onWalletPickerCancel"
    />

    <div
      id="loggingin"
      class="modal hidden"
    >
      <div
        class="command_button boot-button"
      >
        <video
          src="@/assets/boom.mp4"
          muted
          autoplay
          loop
        />
        <div
          class="bottom-booter"
        >
          <h2>
            Signing In To Mint...
          </h2>
          <p style="text-align: center; margin-bottom: 15px; font-size: 12px;">
            Please sign the message<br>with your cryptowallet<br>so the contract lets you mint!<br><br>
          </p>
        </div>
      </div>
    </div>

    <div class="desktop">
      <div id="icon-holder">
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-about"
          @dblclick="showABOUTWindow"
          v-touch:tap="showABOUTWindow"
        >
          <img
            class="abouticon"
            src="@/assets/img/about.png"
            alt="About"
          >
          <h2>THE CREATORS</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-trash"
          @dblclick="connectAccount"
          v-touch:tap="connectAccount"
        >
          <img
            class="trashicon"
            src="@/assets/wallet.png"
            alt="Login"
          >
          <h2>WEB3 CONNECT</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-yourpunks"
          @dblclick="showYourPunks"
          v-touch:tap="showYourPunks"
        >
          <img
            class="yourpunksicon"
            src="@/assets/img/punkicon2.png"
            alt="Your RPUNKS"
          >
          <h2>YOUR RPUNKS</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-trash"
          @dblclick="showLOOKUP"
          v-touch:tap="showLOOKUP"
        >
          <img
            class="punkicon"
            src="@/assets/img/radioactive-symbol.png"
            alt="Head"
          >
          <h2>RPUNK LOOKUP</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-suitup"
          @dblclick="showSuitUp"
          v-touch:tap="showSuitUp"
        >
          <img
            class="punkicon"
            src="@/assets/img/suiticon.png"
            alt="Suit Up"
          >
          <h2>SUIT UP</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-punks"
          @dblclick="showRPUNKSWindow"
          v-touch:tap="showRPUNKSWindow"
        >
          <img
            class="trashicon"
            alt="Trash"
            src="@/assets/img/trash.png"
          >
          <h2>RPUNK GENERATOR</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-pets"
          @dblclick="showRPETSWindow"
          v-touch:tap="showRPETSWindow"
        >
          <img
            src="@/assets/img/peticon.png"
          >
          <h2>RPETS ADOPTER</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-punks"
          @dblclick="showCLAIMCHECKER"
          v-touch:tap="showCLAIMCHECKER"
        >
          <img
            class="punkfolder"
            src="@/assets/img/punkfolder.png"
            alt="RPET Claim Check"
          >
          <h2>CLAIM CHECKER</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-punks"
          @dblclick="showControls"
          v-touch:tap="showControls"
        >
          <img
            class="icon-player"
            src="@/assets/img/audio.png"
            alt="RPUNK FM"
          >
          <h2>RPUNK RADIO</h2>
        </button>

        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-os"
          @dblclick="openOS"
          v-touch:tap="openOS"
        >
          <img
            class="icon-os"
            src="@/assets/os.png"
            alt="OpenSea"
          >
          <h2>THE OPENSEA</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-discord"
          @dblclick="openDiscord"
          v-touch:tap="openDiscord"
        >
          <img
            class="icon-discord"
            src="@/assets/discord.png"
            alt="OpenSea"
          >
          <h2>THE DISCORD</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-lore"
          @dblclick="showLORE"
          v-touch:tap="showLORE"
        >
          <img
            class="loreicon"
            src="@/assets/img/news.png"
            alt="Lore"
          >
          <h2>RPUNK LORE</h2>
        </button>
        <button
          class="icon draggable-icon ui-widget-content"
          id="icon-aidrop"
          @dblclick="openAirdrops"
          v-touch:tap="openAirdrops"
        >
          <img
            class="airdropicon"
            src="@/assets/airplane.png"
            alt="Aidrop Gallery"
          >
          <h2>AIRDROP GALLERY</h2>
        </button>
      </div>

      <div
        id="about"
        class="content resizable draggable-window"
      >
        <div class="control-box close-box">
          <a class="control-box-inner" />
        </div>
        <div class="control-box zoom-box">
          <div class="control-box-inner">
            <div class="zoom-box-inner" />
          </div>
        </div>
        <div class="control-box window-collapse">
          <div class="control-box-inner">
            <div class="window-collapse-inner" />
          </div>
        </div>
        <h1 class="titlebar">
          <span>About</span>
        </h1>
        <div class="inner">
          <div class="icon">
            <img
              src="@/assets/img/about.png"
              alt="Information"
            >
          </div>
          <ul>
            <li style="text-align: left;">
              <h1>Positive Vibrations Only™ Labs</h1>
              <p>
                We promise to provide you with the deepest lore, the highest tech, and the highest-quality pixel art this side of the wastelands.
                Founded in September 2021 by <a
                  href="https://twitter.com/iamwhitelights"
                  target="_blank"
                >@iamwhitelights</a>
                and <a
                  href="https://twitter.com/iamwhitelights"
                  target="_blank"
                >@pixantle</a>,
                since then PVOL has labbed up NFT drops across the Ethereum, Polygon, and Tezos blockchains.
                <br><br>
                Radioactive Punks is our first collectible and first brain collaborative brainchild, so you can bet we'll always be expanding the Radioactive Metaverse.
                <br><br>
                Come join
                <a
                  href="discord.gg"
                  target="_blank"
                >our discord</a>
                and get to know the punks or visit the <a href="https://opensea.io/collection/radioactive-punks">our page on OpenSea</a> to see what's for sale on the secondary market.
                <br><br>
                If you think our lore is rad, be sure to shoot <a
                  href="https://twitter.com/muchalec"
                  target="_blank"
                >@muchalec</a> our Lore King some love on Twitter!
              </p>
            </li>
          </ul>
          <button class="dialog-button command_button close-box">
            Close
          </button>
        </div>
      </div>

      <div
        id="lore"
        class="content resizable draggable-window hidden"
      >
        <div class="control-box close-box">
          <a class="control-box-inner" />
        </div>
        <div class="control-box zoom-box">
          <div class="control-box-inner">
            <div class="zoom-box-inner" />
          </div>
        </div>
        <div class="control-box window-collapse">
          <div class="control-box-inner">
            <div class="window-collapse-inner" />
          </div>
        </div>
        <h1 class="titlebar">
          <span>RPUNK Lore</span>
        </h1>
        <div class="inner">
          <div class="icon">
            <img
              src="@/assets/img/news.png"
              alt="Lore"
            >
          </div>
          <ul>
            <li style="text-align: left;">
              <h1>From the desk of the Lore King...</h1>
              <p v-if="currentLoreChapter === 0">
                Hello my radioactive family, I've been having a wonderful time with you over the past few days. I feel like we've all made some new friends and this community is really starting to bloom. Seeing the effort you've been making to rescue and bring home the punks has been inspiring. So much so that I couldn't sit still and solely be your mod, though I love the role dearly. Over the weekend I dove, with great fervor, into a hole, a research hole. I've been feeling like there has to be something more here. There are a lot of why's and how's I keep thinking of. But I believe I've found something of note and so, if you'd indulge me, I'll start to bring you along for this journey.
                <br><br>
                As most of you know there was a message on the sight, embedded rather discreetly into the console.
                <br><br>
                <strong>This was that message:</strong>
              </p>
              <p
                v-if="currentLoreChapter === 1"
                style="font-family: monospace;"
              >
                The lab is in a state of utter meltdown, and [REDACTED] are dispatching the evacuation team as we speak.
                <br><br>
                [REDACTED] has deemed all personnel, test subjects, and materials in the lab invaluable and in need of immediate recovery. There is a maximum two-week timeline for this mission to be completed successfully before [REDACTED]. The expectation at this time is a cataclysmic event akin to a Chernobyl in each major city. [REDACTED] will prepare fallout shelters and storage facilities for long-term habitation and quarantine.
                <br><br>
                Still, it seems that we’re rapidly advancing toward the inevitable dawn of a nuclear fallout . . . . .
              </p>
              <p
                v-if="currentLoreChapter === 2"
              >
                I've read over this many times in the last 48 hours.
                <br><br>
                No matter what my mind returns to the matter of the "who" here. As I said I've been in quite a fever, turning over every metaphoric stone I could find.
                <br><br>
                I found a lot of moss, disappointing as you'd expect, but I don't let things like that deter me.
              </p>

              <p
                v-if="currentLoreChapter === 3"
              >
                📍 One small pebble was quite intriguing though: 📍
                <br><br>
                ☢️☣️☢️
                <br><br>
                <i>The Society of Epigenetic Radio Alchemists</i> 🔬 (S.E.R.A.) was working on a means of making humans resistant to nuclear fallout through radiation experimentation.
                <br><br>
                At the time, the global state of affairs was dismal, and with their early trials having had great successes, S.E.R.A. was greenlit and given near-full autonomy with the project. At the precipice of a breakthrough *Dr. [REDACTED] caught a glimpse of a green glow 🧪  in the periphery of their vision.
                <br><br>
                Working in this kind of research lab catching a glimpse of a shine or glow is a daily occurrence to some extent. That is to say at that particular moment there wasn’t a cause for alarm. However, though innocuous at first this glow was the first sign, of many mind you, that catastrophe was on the horizon.
              </p>
              <p
                v-if="currentLoreChapter === 4"
              >
                Hello everyone , I had a long day... I felt like I was traversing a fog filled cove, paddling my rowboat ever so steadily. Eventually, I found my fishing spot and dropped my line. It took a while but Fumbles here got his catch: a piece of a transcription. Two workers currently stationed at the lab just chatting. I wonder if they know they're being watched like this.
                <br><br>
                <i>
                  Stolen Transcription #01:<br>👁️Vision 👁️
                  <br><br>
                  “They looked uh...different.”
                  <br><br>
                  “What do you mean different? Different how?”
                  <br><br>
                  “Like... different colors and shit”
                  <br><br>
                  “uhuh... ”
                  <br><br>
                  “I’m not kidding! I was doing the rounds last night y'know and as I finished up at the depot I swore I could see these lights flickering up near the lab. Thought they were startin' to go out or somethin' like that, I don't know. I started to head over to look a little closer but no... not flickering lights."
                  <br><br>
                  "So what was it?"
                  <br><br>
                  "I mean I don’t know what else to say man, they're still people and all… I guess? I've already accepted how it sounds but they were glowing. Some were green and some were blue… It's... It's hard to explain."
                  <br><br>
                  “What uhhhh, are you talking about? Why don't you take the night off I'll cover for ya.”
                  <br><br>
                  “Actually? I hadn’t thought about it at fir [DATA CORRUPTED]”
                </i>
              </p>
              <p v-if="currentLoreChapter === 5">
                It's been a few days since my last update. My sincerest apologies. Like a squirrel I've been gathering supplies for the impending winter.
                S.E.R.A. and their employer know what's coming and what they've ushered in. I want to ensure that we all know what's happening right now that's driving us toward this nuclear winter. I've recently found a journal entry from one of the test subjects. I couldn't just keep it to myself so here it is for all of you to comb through.
                <br><br>
                <i>
                  Journal Entry #01:
                  <br>Tranquility
                  <br>
                  🚬 📵  🚬
                  <br><br>
                  “It's safe at this hour.
                  <br><br>
                  I feel like I can actually think for a minute. Time to yourself is a real luxurious thing. Although context creates contrast, so I have that to thank.
                  <br><br>
                  I'm done for today. They try to do all the testing in ‘random’ spurts but at this point I can time them. They like to start the week off strong. Monday and Tuesday can be a little unpredictable actually and I’m still getting those down. We get woken up sometime between 4:30 and 6:00am, on one of the two days, to have our vitals checked and samples pulled. Never a very pleasant experience.
                  <br><br>
                  The rest of the day is spent either being or waiting to be tested on. Sometimes they keep you awake and sometimes they don’t.  They don't talk much and they don't want us to either. I spend so much time with them but I don't know the first thing about any of the workers, aside from their names. Or what I think are their names.
                  <br><br>
                  I’d also love to say the team at the lab are some weekend warriors but sadly that’s not the case. Their work ethic is commendable I guess though...
                  <br><br>
                  I want a half decent meal. What a thing to want, not even good, just half decent. At first they treated us like royalty. Hindsight is 20/20 and all but still, how did I not see through that?
                  <br><br>
                  Eh...Things are bleak and I’m just bitter…
                  <br><br>
                  I can tell something’s changed recently. It feels like there are more eyes on me than before. I don’t know why, it just does.”
                </i>
              </p>
            </li>
          </ul>
          <button
            class="dialog-button command_button"
            @click="currentLoreChapter++"
          >
            Next Chapter
          </button>
        </div>
      </div>

      <div
        id="claimchecker"
        class="content resizable draggable-window hidden"
      >
        <div class="control-box close-box">
          <a class="control-box-inner" />
        </div>
        <div class="control-box zoom-box">
          <div class="control-box-inner">
            <div class="zoom-box-inner" />
          </div>
        </div>
        <div class="control-box window-collapse">
          <div class="control-box-inner">
            <div class="window-collapse-inner" />
          </div>
        </div>
        <h1 class="titlebar">
          <span>RPET CLAIM CHECK</span>
        </h1>
        <div class="inner">
          <div class="icon">
            <img
              src="@/assets/img/peticon.png"
              alt="RPETS Icon"
            >
          </div>
          <ul>
            <li style="text-align: center;">
              <p>
                Type any RPUNK's number, aka token ID, below to check if it is eligible to claim a free RPET!
              </p>
            </li>
          </ul>
          <div class="punk-number-input">
            <label for="punk-number">Punk #:</label>
            <input
              type="number"
              id="punk-number"
              name="punk-number"
              v-model="punkNumberToCheck"
              min="0"
              max="2999"
            >
          </div>
          <p style="text-align: center; margin-bottom: 20px;">
            RPUNK Can Still Claim an RPET:<br>
            <span style="text-transform: uppercase;">
              {{ lastPunkCheckedWasElibile !== undefined ? lastPunkCheckedWasElibile : '...' }}
            </span>
          </p>
          <button
            class="dialog-button command_button"
            @click="checkIfPunkIsEligible"
          >
            Check it!
          </button>
        </div>
      </div>

      <div
        id="pets"
        class="content resizable draggable-window hidden"
      >
        <div class="control-box close-box">
          <a class="control-box-inner" />
        </div>
        <div class="control-box zoom-box">
          <div class="control-box-inner">
            <div class="zoom-box-inner" />
          </div>
        </div>
        <div class="control-box window-collapse">
          <div class="control-box-inner">
            <div class="window-collapse-inner" />
          </div>
        </div>
        <h1 class="titlebar">
          <span>RPETS</span>
        </h1>
        <div class="inner">
          <ul>
            <div class="icon">
              <img
                src="@/assets/img/peticon.png"
                alt="RPETS Icon"
              >
            </div>
            <li style="text-align: left;">
              <h1>RPETS MINT & ADOPT</h1>
              <p>
                <br><br>
                Price:<br>0.05ETH, Free Claim for RPUNKs
                <br><br>
                Duration:<br>Closed
                <br><br>
                Pets Left:<br>
                {{ petsLeft + 1 }} / 3k
                <br><br>
                Public Mint:<br>
                {{ timeLeft }}
                <br><br>
                Free Claim:<br>
                STILL ENGAGED
                <br><br>
                Free RPET Claims Left:<br>
                {{ claimsLeftString }}
                <br><br>
                Click the correct button below for what you'd like to do, then confirm the single minting transaction in Metamask to claim/buy all of your pets at once.
                <br><br>
                We've leveraged <a
                  href="https://www.erc721a.org/"
                  target="_blank"
                >Chiru Labs ERC721A standard</a> to optimize gas fees on batch mints!

                <br><br>
                Please leave this tab open while the transaction completes to ensure success. The transaction can take a few minutes to complete once confirmed.
              </p>
            </li>
          </ul>
          <button
            class="dialog-button command_button claim-pets"
            @click="claimPets"
            :disabled="!petsPrivatelyActivated || pending || petsLeftToClaim === 0"
          >
            {{ pending ? 'Claiming...' : `Claim ${petsLeftToClaim} Free Pets!` }}
          </button>

          <div class="quantity-input">
            <label for="quantity">Quantity (1 to 10):</label>
            <input
              type="number"
              id="quantity"
              name="quantity"
              v-model="petsPurchaseQuantity"
              min="1"
              max="10"
            >
          </div>
          <button
            class="dialog-button command_button buy-pets"
            @click="buyPets"
            :disabled="!petsPubliclyActivated || pending"
          >
            {{ pending ? 'Minting...' : `Buy ${petsPurchaseQuantity} Pets!` }}
          </button>
        </div>
      </div>

      <div
        id="lookup"
        class="content resizable draggable-window hidden"
      >
        <div class="control-box close-box">
          <a class="control-box-inner" />
        </div>
        <div class="control-box zoom-box">
          <div class="control-box-inner">
            <div class="zoom-box-inner" />
          </div>
        </div>
        <div class="control-box window-collapse">
          <div class="control-box-inner">
            <div class="window-collapse-inner" />
          </div>
        </div>
        <h1 class="titlebar">
          <span>RPUNK Lookup</span>
        </h1>
        <div class="inner">
          <ul>
            <div class="icon">
              <img
                src="@/assets/img/peticon.png"
                alt="RPETS Icon"
              >
            </div>
            <li style="text-align: left;">
              <h1>RPUNK Lookup</h1>
              <p>
                Every punk's image and metadata lives fully on-chain. This asks the original <a
                  href="https://etherscan.io/address/0x073ca28e04719c05a5a48c1d992091b4075a0f84#code"
                  target="_blank"
                >RPUNKS contract</a> for its web3:// tokenURI and renders whatever the chain sends back.
                <br><br>
                Right click on the image to save it as an SVG!
              </p>
            </li>
          </ul>
          <div class="punk-number-input">
            <label for="punk-number">Punk Number:</label>
            <input
              type="number"
              id="punk-number"
              name="punk-number"
              v-model="punkNumberSearch"
              min="0"
              max="2999"
            >
          </div>
          <button
            class="dialog-button command_button punk-lookup"
            @click="lookupPunk"
          >
            {{ pending ? 'Searching...' : `Search` }}
          </button>
        </div>
      </div>



      <div
        id="headshot"
        class="content resizable draggable-window hidden"
      >
        <div class="control-box close-box">
          <a class="control-box-inner" />
        </div>
        <div class="control-box zoom-box">
          <div class="control-box-inner">
            <div class="zoom-box-inner" />
          </div>
        </div>
        <div class="control-box window-collapse">
          <div class="control-box-inner">
            <div class="window-collapse-inner" />
          </div>
        </div>
        <h1 class="titlebar">
          <span>{{ searchedPunkData ? searchedPunkData.name : 'Headshot' }}</span>
        </h1>
        <div class="inner">
          <div
            v-if="searchedPunkData"
            class="punk-detail"
          >
            <button
              class="command_button back-button"
              @click="backToLookup"
            >
              &lsaquo; RPUNK Lookup
            </button>
            <PunkDetail
              :punk="searchedPunkData"
              @suit-up="suitUpPunk"
            />
          </div>
        </div>
      </div>

      <div
        id="controls"
        class="content noscroll draggable-window text-center"
      >
        <div
          class="control-box close-box"
          @click="()=>{}"
        >
          <a class="control-box-inner" />
        </div>
        <h1 class="titlebar noright">
          <span>RPUNK FM</span>
        </h1>
        <div class="inner">
          <div id="controls-inner">
            <button
              class="command_button"
              @click="skip(-100)"
            >
              &laquo;
            </button>
            <button
              class="command_button"
              @click="skip(-30)"
            >
              &lsaquo;
            </button>
            <button
              class="command_button"
              @click="playSecretSong"
            >
              Play
            </button>
            <button
              class="command_button"
              @click="pauseSecretSong"
            >
              Pause
            </button>
            <button
              class="command_button"
              @click="skip(30)"
            >
              &rsaquo;
            </button>
            <button
              class="command_button"
              @click="skip(100)"
            >
              &raquo;
            </button>
            <hr>
            Tunes by @muchalec
          </div>
        </div>
      </div>

      <YourPunksWindow
        ref="yourPunks"
        :account-address="accountAddress"
        @suit-up="suitUpPunk"
      />

      <SuitUpWindow ref="suitUp" />

      <TransactionWindow
        v-if="pending || minted"
        :pending="pending"
        :minted="minted"
        :pending-tx-u-r-l="pendingTxURL"
        :finished-tx-string="finishedTxString"
      />

      <div
        id="errorWindow"
        class="alert alert-stop content noscroll text-center hidden"
        style="width: 20%;"
      >
        <div class="inner">
          <p style="font-weight: normal;">
            Oh c'mon!
          </p>
          <br>
          <p>
            What'd I <i>just</i> tell you? Punks these days... sheesh.
          </p>
          <button class="command_button sorry-button close-button">
            NGMI DUDE
          </button>
        </div>
      </div>
    </div>

    <div id="audio-holder hidden">
      <audio
        id="sound_boot"
        class="handsoff hidden"
        preload="auto"
      >
        <source
          src="~@/assets/sound/startup.mp3"
          type="audio/mpeg"
        >
      </audio>
      <audio
        id="sound_window_close"
        class="handsoff hidden"
        preload="auto"
      >
        <source
          src="~@/assets/sound/ui/window_close.mp3"
          type="audio/mpeg"
        >
      </audio>
      <audio
        id="sound_window_collapse"
        class="handsoff hidden"
        preload="auto"
      >
        <source
          src="~@/assets/sound/ui/window_collapse.mp3"
          type="audio/mpeg"
        >
      </audio>
      <audio
        id="sound_window_expand"
        class="handsoff hidden"
        preload="auto"
      >
        <source
          src="~@/assets/sound/ui/window_expand.mp3"
          type="audio/mpeg"
        >
      </audio>
      <audio
        id="sound_window_open"
        class="handsoff hidden"
        preload="auto"
      >
        <source
          src="~@/assets/sound/ui/window_open.mp3"
          type="audio/mpeg"
        >
      </audio>
      <audio
        id="sound_window_stopmoving"
        class="handsoff hidden"
        preload="auto"
      >
        <source
          src="~@/assets/sound/ui/window_stopmoving.mp3"
          type="audio/mpeg"
        >
      </audio>
      <audio
        id="sound_window_moving"
        class="handsoff hidden"
        preload="auto"
      >
        <source
          src="~@/assets/sound/ui/window_moving.mp3"
          type="audio/mpeg"
        >
      </audio>
      <audio
        id="secret_song"
        class="handsoff hidden"
        preload="auto"
        ref="player"
        loop
        src="/songs/day16(idea2).mp3"
        type="audio/mpeg"
      />
    </div>
  </div>
</template>

<script>
import { parseEther } from 'viem'
import RADIOACTIVEPUNKS from '@/assets/RADIOACTIVEPUNKS.json'
import RADIOACTIVEPETS from '@/assets/RADIOACTIVEPETS.json'
import TransactionWindow from '@/components/TransactionWindow.vue'
import YourPunksWindow from '@/components/YourPunksWindow.vue'
import PunkDetail from '@/components/PunkDetail.vue'
import SuitUpWindow from '@/components/SuitUpWindow.vue'
import walletLogin from '@/mixins/walletLogin'
import { bringToFront } from '@/windowStack'
import {
  RPUNKS_ADDRESS,
  RPETS_ADDRESS,
  read,
  readMany,
  disconnectWallet,
  signLogin,
  fetchPunkMetadata,
  onConnectionChange,
  estimateGasWithBuffer,
  sendContractTx,
  waitForMintedTokenIds,
  isUserRejection
} from '@/web3'

const PET_PRICE = parseEther('0.05')

const rpunks = { address: RPUNKS_ADDRESS, abi: RADIOACTIVEPUNKS.abi }
const rpets = { address: RPETS_ADDRESS, abi: RADIOACTIVEPETS.abi }

export default {
  name: 'Home',
  mixins: [walletLogin],
  props: {
    msg: String
  },
  components: {
    TransactionWindow: TransactionWindow,
    YourPunksWindow: YourPunksWindow,
    PunkDetail: PunkDetail,
    SuitUpWindow: SuitUpWindow
  },
  data () {
    return {
      // core vars
      walletConnected: false,
      accountAddress: '',
      signature: '',

      activated: false,

      purchaseCount: 1,

      // ux vars
      minting: false,
      minted: false,
      pending: false,

      showDisconnectMenu: false,

      punksLeft: 'XXXX',
      petsLeft: undefined,
      punksBalance: 0, // how many punks they already own
      ownedPunkTokenIDs: [],

      petsBalance: 0, // how many pets they already own
      petsPrivateActivationTime: undefined,
      petsPublicActivationTime: undefined,
      petsPrivatelyActivated: false,
      petsPubliclyActivated: false,

      punkNumberToCheck: 0,
      lastPunkCheckedWasElibile: undefined,
      petsPurchaseQuantity: 1,
      petsLeftToClaim: 0,
      timeLeft: '',

      punkNumberSearch: 0,
      searchedPunkData: undefined,

      currentLoreChapter: 0,

      pendingTxURL: '',
      finishedTxString: '',

      timeXZLeft: '',
      timer: undefined,

      trackNumber: 0,
      playlist: [
        '/songs/789.mp3',
        '/songs/BBs.mp3',
        '/songs/day16(idea2).mp3',
        '/songs/RAININ(idea).mp3',
        '/songs/secret_song.mp3'
      ]
    }
  },
  computed: {
    claimsLeftString () {
      return this.petsLeftToClaim <= 0
        ? 'None'
        : this.petsLeftToClaim
    }
  },

  mounted () {
    this.startUpMacOS8()

    // keep the music and ui sounds quiet while developing
    if (process.env.NODE_ENV === 'development') {
      this.$el.querySelectorAll('audio').forEach((audio) => { audio.muted = true })
    }

    // drop the login if the wallet disconnects or switches accounts
    this.unwatchConnection = onConnectionChange((connection) => {
      if (this.walletConnected && connection.address !== this.accountAddress) {
        this.resetLogin()
      }
    })
  },

  beforeDestroy () {
    this.unwatchConnection()
  },

  methods: {
    async showRPETSWindow () {
      await this.connectIfNecessary()
      if (!this.walletConnected) { return }

      const ownedTokenIDs = await readMany(
        Array.from({ length: this.punksBalance }, (_, i) => ({
          ...rpunks,
          functionName: 'tokenOfOwnerByIndex',
          args: [this.accountAddress, BigInt(i)]
        }))
      )
      this.ownedPunkTokenIDs = ownedTokenIDs.map(Number)

      const claimed = await readMany(
        this.ownedPunkTokenIDs.map(id => ({
          ...rpets,
          functionName: 'punkIsClaimed',
          args: [BigInt(id)]
        }))
      )
      this.petsLeftToClaim = claimed.filter(isClaimed => !isClaimed).length

      this.openWindow('#pets')
    },

    async checkIfPunkIsEligible () {
      const punkIsClaimed = await read({
        ...rpets,
        functionName: 'punkIsClaimed',
        args: [BigInt(this.punkNumberToCheck)]
      })
      this.lastPunkCheckedWasElibile = !punkIsClaimed
    },

    toggleDisconnectMenu () {
      this.showDisconnectMenu = !this.showDisconnectMenu
    },

    openOS () {
      window.open('https://opensea.io/collection/radioactive-punks', '_blank')
    },

    openDiscord () {
      window.open('https://discord.gg/7YVaRwrdEt', '_blank')
    },

    openAirdrops () {
      window.open('https://opensea.io/collection/radioactive-artdrops', '_blank')
    },

    openWindow (selector) {
      bringToFront(jQuery(selector).removeClass('hidden').get(0))
      jQuery('#sound_window_open').trigger('play')
    },

    showABOUTWindow () {
      this.openWindow('#about')
    },

    showLOOKUP () {
      this.openWindow('#lookup')
    },

    showSuitUp () {
      this.openWindow('#suitup')
    },

    // from a punk's detail view. focus happens on mousedown (see enableWindowOrder), so this click
    // comes after the detail window was raised and leaves #suitup on top of it
    suitUpPunk (punkId) {
      this.showSuitUp()
      this.$refs.suitUp.suitUp(punkId)
    },

    showHeadshotWindow () {
      this.openWindow('#headshot')
    },

    backToLookup () {
      jQuery('#headshot').addClass('hidden')
      bringToFront(document.querySelector('#lookup'))
      jQuery('#sound_window_close').trigger('play')
    },

    showLORE () {
      this.openWindow('#lore')
    },

    async showYourPunks () {
      await this.connectIfNecessary()
      if (!this.walletConnected) { return }

      this.openWindow('#yourpunks')
      this.$refs.yourPunks.load()
    },

    showRPUNKSWindow () {
      const routeData = this.$router.resolve({
        name: 'PunkGenerator'
      })
      window.open(routeData.href, '_blank')
    },

    showControls () {
      this.openWindow('#controls')
    },

    async connectIfNecessary () {
      if (this.walletConnected) { return }
      await this.connectAccount()
    },

    async showCLAIMCHECKER () {
      await this.connectIfNecessary()
      if (!this.walletConnected) { return }

      this.openWindow('#claimchecker')
    },

    showSigningIn () {
      jQuery('#loggingin').removeClass('hidden')
    },

    hideSigningIn () {
      jQuery('#loggingin').addClass('hidden')
    },

    bootUp () {
      jQuery('#sound_boot').trigger('play')
      jQuery('#boot-button').hide()
      jQuery('#boot').hide()
      this.playSecretSong()

      this.updateTime()
      this.timer = window.setInterval(this.updateTime, 1000)
    },

    skip (amount) {
      if (amount === 100) {
        this.trackNumber += 1
        if (this.trackNumber >= this.playlist.length) {
          this.trackNumber = 0
        }

        this.$refs.player.src = this.playlist[this.trackNumber]
        // Assign a song time of zero
        this.$refs.player.currentTime = 0
        // Play the song
        this.$refs.player.play()
      } else if (amount === -100) {
        // skip song
      } else {
        this.$refs.player.currentTime += amount
      }
    },

    startUpMacOS8 () {
      this.clock()
      this.enableWindowDrag()
      this.enableWindowResize()
      this.enableWindowClose()
      this.enableWindowOrder()
      this.enableNav()
      this.enableWindowZoom()
      this.enableDesktopIcons()
      this.enableWindowCollapse()
    },

    playSecretSong () {
      jQuery('#secret_song').prop('volume', 0.4)
      jQuery('#secret_song').trigger('play')
    },

    pauseSecretSong () {
      jQuery('#secret_song').trigger('pause')
    },

    showNextPage () {
      this.currentLoreChapter++
      this.showLore = true
    },

    showPreviousPageOrHide () {
      this.currentLoreChapter--
      if (this.currentLoreChapter < 0) {
        this.showLore = false
      }
    },

    // Init and set the OS clock
    clock () {
      jQuery('#time').text(this.secondsToTimeFormatted())
      setInterval(() => {
        jQuery('#time').text(this.secondsToTimeFormatted())
      }, 1000)
    },

    updateTime () {
      // Get today's date and time
      var now = new Date().getTime()

      // Find the distance between now and the count down date
      let distance = '1648828800000' - now // just a default in case contract isn't working
      if (this.petsPublicActivationTime) {
        distance = (this.petsPublicActivationTime * 1000) - now
      }

      // Time calculations for days, hours, minutes and seconds
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = Math.floor((distance % (1000 * 60)) / 1000)

      // Display the result in the element with id="demo"
      this.timeLeft = hours + 'h ' +
        minutes + 'm ' + seconds + ' S'


      this.timeLeft = 'INACTIVE'

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(this.timer)
        this.timeLeft = 'ACTIVE'
      }
    },
    // connects the wallet and loads its punk/pet state; no signature needed to read
    async connectAccount () {
      try {
        const address = await this.connectWalletOnly()
        if (!address) { return }
        this.accountAddress = address

        const [
          activated,
          punksLeft,
          activationTime,
          punksBalance,
          petsPrivatelyActivated,
          petsPubliclyActivated,
          petsSupply,
          petsPrivateActivationTime,
          petsPublicActivationTime,
          petsBalance
        ] = await readMany([
          { ...rpunks, functionName: 'activated' },
          { ...rpunks, functionName: 'PUNKS_LEFT' },
          { ...rpunks, functionName: 'activationTime' },
          { ...rpunks, functionName: 'balanceOf', args: [this.accountAddress] },
          { ...rpets, functionName: 'privatelyActivated' },
          { ...rpets, functionName: 'publiclyActivated' },
          { ...rpets, functionName: 'totalSupply' },
          { ...rpets, functionName: 'privateActivationTime' },
          { ...rpets, functionName: 'publicActivationTime' },
          { ...rpets, functionName: 'balanceOf', args: [this.accountAddress] }
        ])
        this.activated = activated
        this.punksLeft = Number(punksLeft)
        this.activationTime = Number(activationTime)
        this.punksBalance = Number(punksBalance)
        this.petsPrivatelyActivated = petsPrivatelyActivated
        this.petsPubliclyActivated = petsPubliclyActivated
        this.petsLeft = 2999 - Number(petsSupply)
        this.petsPrivateActivationTime = Number(petsPrivateActivationTime)
        this.petsPublicActivationTime = Number(petsPublicActivationTime)
        this.petsBalance = Number(petsBalance)

        // update UX
        this.walletConnected = true

        // only for when i need to get hodlers
        // this.getAllOwners()
      } catch (e) {
        console.warn('Wallet connect failed')
        console.warn(e)
        this.accountAddress = ''

        if (isUserRejection(e)) {
          window.alert('Could not connect your wallet because the request was denied.')
        } else {
          window.alert('Wallet connect failed.')
        }
      }
    },

    // the mint contracts verify this EIP-712 login signature, so it's only asked for right before minting.
    // resolves true once we have it for the connected wallet
    async signInIfNecessary () {
      if (this.signature) { return true }
      this.showSigningIn()
      try {
        this.signature = await signLogin(this.accountAddress)
        return true
      } catch (e) {
        console.warn(e)
        window.alert(isUserRejection(e)
          ? 'Minting needs your signature so the contract knows it\'s you. Please try again.'
          : 'Signing in failed.')
        return false
      } finally {
        this.hideSigningIn()
      }
    },

    async logOut () {
      await disconnectWallet()
      this.resetLogin()
    },

    resetLogin () {
      this.walletConnected = false
      this.accountAddress = ''
      this.signature = ''
      this.punksBalance = 0
      this.petsBalance = 0
      this.ownedPunkTokenIDs = []
      this.petsLeftToClaim = 0
      this.showDisconnectMenu = false
      jQuery('#yourpunks').addClass('hidden')
    },
    claimPets () {
      return this.mintPets('mintPetsForPunks', [], {
        estimateValue: parseEther('0.02')
      })
    },

    buyPets () {
      const quantity = BigInt(this.petsPurchaseQuantity)
      return this.mintPets('mintPetsPublic', [quantity], {
        value: PET_PRICE * quantity
      })
    },

    // ledgers sign with v = 0/1 instead of 27/28, so the contract rejects the first
    // attempt with "No cheaters!" and we retry once with v + 27
    async mintPets (functionName, leadingArgs, { value, estimateValue } = {}, isLedgerRetry = false) {
      await this.connectIfNecessary()
      if (!this.walletConnected || !(await this.signInIfNecessary())) { return }

      this.pending = true
      this.minted = false

      try {
        const args = [
          ...leadingArgs,
          isLedgerRetry ? this.signature.v + 27 : this.signature.v,
          this.signature.r,
          this.signature.s
        ]
        const gas = await estimateGasWithBuffer({
          ...rpets,
          functionName,
          args,
          account: this.accountAddress,
          value: estimateValue || value
        })
        const hash = await sendContractTx({ ...rpets, functionName, args, value, gas })

        this.pendingTxURL = this.getTransactionURL(hash)

        // show loading status while confirming on chain
        const tokenIds = await waitForMintedTokenIds(hash, RPETS_ADDRESS, RADIOACTIVEPETS.abi)
        this.pending = false
        this.finishedTxString = tokenIds.length > 1
          ? '<h2>Congrats!</h2><strong>You just adopted Radioactive Pets</strong>'
          : '<h2>Congrats!</h2><strong>You just adopted Radioactive Pet</strong>'
        tokenIds.forEach((id) => {
          const url = this.getURLForTokenId(id)
          this.finishedTxString += ` <a href="${url}" target="_blank">#${id}</a>`
        })

        // SUCCESS!
        this.minted = true
        this.petsLeft = Number(await read({ ...rpets, functionName: 'MINTS_LEFT' }))
      } catch (e) {
        this.pending = false
        this.minted = false
        console.log(e)
        if (!this.signature) {
          window.alert('Signature rejected. Minting needs it, please try again.')
        } else {
          if (e.code === 'CALL_EXCEPTION') {
            const url = this.getTransactionURL(e.transactionHash)
            window.alert(`<strong>Minting <a href="${url}" target="_blank">Failed</a></strong><br>Please try again`)
          } else if (e.code === 'TRANSACTION_REPLACED') {
            if (e.reason === 'cancelled') {
              window.alert('<strong>Mint Cancelled</strong><br>Hit the button')
            } else if (e.reason === 'replaced') {
              const url = this.getTransactionURL(e.replacement.transactionHash)
              window.alert(`<strong>Mint Sped Up</strong><br>New Mint TX<a href="${url}" target="_blank">Here</a>`)
            }
          } else if (isUserRejection(e)) {
            this.status = '<strong>Mint Rejected</strong><br>Hit the button'
          } else if (e.message.includes('Only 10 for first 10m')) {
            this.status = '<strong>Mint Rejected</strong><br>Only 10 for first 10 mins'
          } else if (e.message.includes('Owns max amount')) {
            this.status = '<strong>Mint Rejected</strong><br>Only 100 mints per owner'
          } else if (e.message.includes('No cheaters!') && !isLedgerRetry) {
            return this.mintPets(functionName, leadingArgs, { value, estimateValue }, true)
          } else {
            // check for various failing mint states of wait()
            this.status = 'Minting Failure<br>Use A Hot Wallet'
          }
        }
      }

      // Update UX no matter what happens
      this.pending = false
    },
    /* UTILITIES */

    split (array, n) {
      const [...arr] = array
      var res = []
      while (arr.length) {
        res.push(arr.splice(0, n))
      }
      return res
    },

    getURLForTokenId (tokenId) {
      return `https://opensea.io/assets/ethereum/${RPETS_ADDRESS}/${tokenId}`
    },

    getTransactionURL (hash) {
      return `https://etherscan.io/tx/${hash}`
    },


    async getAllOwners () {
      const holders = []
      for (let i = 0; i <= 1615; i++) {
        console.log(`owner index ${i}`)
        try {
          const tokenId = await read({ ...rpunks, functionName: 'tokenByIndex', args: [BigInt(i)] })
          const ownerAddress = await read({ ...rpunks, functionName: 'ownerOf', args: [tokenId] })
          holders.push(ownerAddress)
        } catch (error) {
          console.log('the end')
        }
      }
      const uniqueHolders = [...new Set(holders)]
      const splitArrays = this.split(uniqueHolders, 50)

      const stringified = JSON.stringify(splitArrays)

      console.log(stringified)
    },

    async getAllTokens () {
      const holders = []
      for (let i = 0; i <= 1614; i++) {
        console.log(`owner index ${i}`)
        try {
          const tokenId = await read({ ...rpunks, functionName: 'tokenByIndex', args: [BigInt(i)] })
          holders.push(Number(tokenId))
        } catch (error) {
          console.log('the end')
          break
        }
      }
      console.log(JSON.stringify(holders))
    },

    // read-only, so no wallet needed
    async lookupPunk () {
      let data
      try {
        data = await fetchPunkMetadata(this.punkNumberSearch)
      } catch (e) {
        console.warn(e)
        window.alert(`Punk #${this.punkNumberSearch} could not be found.`)
        return
      }
      this.searchedPunkData = { id: Number(this.punkNumberSearch), ...data }
      this.showHeadshotWindow()
    },

    isMobile () {
      try {
        document.createEvent('TouchEvent')
        return true
      } catch (e) {
        return false
      }
    },

    secondsToTimeFormatted () {
      var d = new Date()
      d.setHours(d.getHours()) // Eastern Time Zone adjustment
      return this.dateFormatter(d)
    },

    dateFormatter (d) {
      var hours = d.getHours()
      var minutes = d.getMinutes()
      var seconds = d.getSeconds()
      var ampm = hours >= 12 ? 'PM' : 'AM'
      hours = hours % 12
      hours = hours || 12 // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds
      return hours + ':' + minutes + ':' + seconds + ' ' + ampm
    },

    enableWindowDrag () {
    // Make windows movable
      jQuery('.draggable-window').draggable({
        handle: 'h1.titlebar',
        containment: jQuery('.desktop'),
        start: (event) => {
          jQuery('#sound_move_stop').trigger('play')
        },
        stop: (event, ui) => {
          jQuery('#sound_move_stop').trigger('play')
        }
      })
    },

    enableWindowResize () {
    // Make windowds resizable
      jQuery('.resizable .inner').resizable({
        handles: 'se',
        containment: jQuery('.desktop'),
        alsoResize: jQuery(this).parent('div.content'),
        stop: (event, ui) => {
          jQuery('#sound_move_stop').trigger('play')
        }
      })
    },

    // Zoom Box -- Make Window Full Screen and toggle back
    enableWindowZoom () {
      jQuery('.zoom-box').on('click', (event) => {
        const b = event.target.closest('.content')
        const isMax = jQuery(event.target).data('max')
        const i = jQuery(b).children('.inner')
        if (!isMax) {
          jQuery(b)
            .css('width', '99%')
            .css('height', '95%')
            .css('left', '.5rem')
            .css('top', '2.5rem')
          jQuery(i)
            .css('width', '99%')
            .css('height', '95%')
            .css('left', '.5rem')
            .css('top', '2.5rem')

          jQuery(event.target)
            .data('width', jQuery(b).css('width'))
            .data('height', jQuery(b).css('height'))
            .data('top', jQuery(b).css('top'))
            .data('left', jQuery(b).css('left'))
            .data('max', true)

          jQuery('#sound_window_expand').trigger('play')
        } else {
          jQuery(b).css({ width: '', height: '', left: '', top: '' })
          jQuery('#sound_window_collapse').trigger('play')
          jQuery(i).removeAttr('style')
          jQuery(event.target).data('max', false)
        }
      })
    },

    // Collapse/Expand window -- Minimize the window to just the title bar
    enableWindowCollapse () {
      jQuery('.window-collapse').on('click', (event) => {
        const contentBox = jQuery(event.target).closest('.content')
        const shadeHeight = jQuery(event.target).data(
          'shade-height',
          jQuery(event.target).css('height')
        )

        if (jQuery(event.target).hasClass('shade')) {
          jQuery(contentBox).removeClass('hidden-window')
          jQuery(contentBox)
            .children('div.inner')
            .first()
            .children('.ui-resizable-handle')
            .first()
            .removeClass('hidden')
          jQuery(contentBox).css('height', shadeHeight)
          jQuery(event.target).removeClass('shade')
          jQuery('#sound_window_expand').trigger('play')
        } else {
          jQuery(contentBox).addClass('hidden-window')
          jQuery(contentBox).css('min-height', '0px')
          jQuery(contentBox)
            .children('div.inner')
            .first()
            .children('.ui-resizable-handle')
            .first()
            .addClass('hidden')
          jQuery(contentBox).css('height', '')
          jQuery(event.target).addClass('shade')
          jQuery('#sound_window_collapse').trigger('play')
        }
      })
    },

    // Close Box -- Close the window when clicked
    enableWindowClose () {
      jQuery('.close-box, .boot-button, .close-button')
        .on(
          'click',
          (event) => {
            const a = event.target.closest('.content')
            jQuery(a).addClass('hidden')
            jQuery('#sound_window_close').trigger('play')
          }
        )
    },

    enableNav () {
      jQuery('.menu-container')
        .on('click tap', (event) => {
          jQuery(event.target.closest('.menu-container')).children('.menu').show()
        })

      jQuery('.menu-container').on('mouseleave', (event) => {
        jQuery(event.target.closest('.menu-container')).children('ul').hide()
      })

      // Enable menu items to be clickable by default and open a windows/app with the same name
      jQuery('.nav-list li ul li').on('click', (event) => {
        if (!jQuery(event.target).hasClass('disabled')) {
          this.openWindow('#' + jQuery(event.target.closest('li')).get(0).id.split('-')[1])
        }
      })
    },

    enableDesktopIcons () {
      // Mobile opens icons on tap; only desktop can rearrange them
      if (!this.isMobile()) {
        jQuery('.draggable-icon').draggable({})
      }
    },

    enableWindowOrder () {
      // Make sure the active window is on top. mousedown, like a real desktop: it beats any click
      // handler that opens another window, and delegating covers windows mounted later
      jQuery('.desktop').on('mousedown', '.content', (event) => {
        bringToFront(event.currentTarget)
      })
    }
  }
}
</script>

<style lang="scss">

@font-face {
  font-family: 'Small Pixel';
  src:
    url('~@/assets/fonts/Small-Pixel.woff') format('woff'),
    url('~@/assets/fonts/Small-Pixel.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'DS-Digital';
  src:
    url('~@/assets/fonts/DS-Digital-BoldItalic.woff2') format('woff2'),
    url('~@/assets/fonts/DS-Digital-BoldItalic.woff') format('woff'),
    url('~@/assets/fonts/DS-Digital-BoldItalic.ttf') format('truetype');
  font-weight: bold;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'DS-Digital';
  src:
    url('~@/assets/fonts/DS-Digital.woff2') format('woff2'),
    url('~@/assets/fonts/DS-Digital.woff') format('woff'),
    url('~@/assets/fonts/DS-Digital.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'DS-Digital';
  src:
    url('~@/assets/fonts/DS-Digital-Italic.woff2') format('woff2'),
    url('~@/assets/fonts/DS-Digital-Italic.woff') format('woff'),
    url('~@/assets/fonts/DS-Digital-Italic.ttf') format('truetype');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'DS-Digital';
  src:
    url('~@/assets/fonts/DS-Digital-Bold.woff2') format('woff2'),
    url('~@/assets/fonts/DS-Digital-Bold.woff') format('woff'),
    url('~@/assets/fonts/DS-Digital-Bold.ttf') format('truetype');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Charcoal';
  src:
    url(data:application/font-woff2;charset=utf-8;base64,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) format('woff2'),
         url(data:application/font-woff;charset=utf-8;base64,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) format('woff');
  font-weight: normal;
  font-style: normal;
}

/*
 * NAV
 */
nav {
  background: transparent;
  margin: 0 0 1em;
  padding: 0;
  position: relative;
  width: 100%;
  z-index: 9900;
}

ul.menu {
  display: none;
  float: left;
  margin-left: -0.5rem;
  padding: 0;
  position: absolute;
  background-color: #f3fdea;
  color: #000;
  font-size: 1.25rem;
  list-style-type: none;
}

.menu {
  li {
    span {
      position: relative;
      bottom: 3px;
      left: 2px;
    }
  }
}

#macoslogo img {
  height: 1.25rem;
  width: 1.25rem;
  margin-top: 1px;
}

.nav-list #time,
.nav-list #macoslogo {
  float: right;
}

.nav-list li {
  float: left;
  height: 1.75rem;
  padding: 0.25rem 0.5rem 0;
  font-size: 14px;
}

.nav-list li:hover ul.menu li {
  clear: both;
  box-sizing: content-box;
  width: 100%;
}

.nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
}

.nav-wrapper {
  border-radius: 5px 5px 0 0;
  box-shadow: inset 1px 1px 0 0 #888;
  display: inline-block;
  height: 100%;
  padding: 0 1rem 5px;
  width: 100%;
  background: url('~@/assets/img/titlebar-bg.png') no-repeat center center;
  min-height: 28px;
  background-size: 100% 100%;
}

.nav-list #time:hover {
  background-color: inherit;
  color: inherit;
}

.nav-wrapper ul li:hover {
  background-color: #339;
  color: #fff;
  cursor: pointer;
}

.nav-list ul > li.noimg {
  padding-left: 1em !important;
}

.nav-wrapper ul li.disabled {
  color: #777;
}

.nav-wrapper ul {
  font-size: 1.25rem;
}

#app {
  height: 100%;
  width: 100%;
  display: block;
  position: relative;
}

/*
 * SCROLLBAR
 */

::-webkit-scrollbar {
  width: 16px;
  margin-bottom: 3em;
  margin-bottom: 100px;

  &:hover {
    cursor: pointer;
  }
}

::-webkit-scrollbar-button:start {
  display: block;
  width: 16px;
  height: 16px;
  top: 16px;
  background-color: #dedede;
  box-shadow: inset 1px 1px 0 #fff, inset -1px -1px 0 #bcbcbc;
}

::-webkit-scrollbar-button:start:vertical {
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}

::-webkit-scrollbar-button:start:vertical:decrement {
  background:
    linear-gradient(transparent 75%, #000 0) 50%/8px 4px no-repeat,
    linear-gradient(transparent 50%, #000 0) 50%/6px 4px no-repeat,
    linear-gradient(transparent 25%, #000 0) 50%/4px 4px no-repeat,
    linear-gradient(#000 50%, #000 0) 50%/2px 4px no-repeat,
    #dedede;
}

::-webkit-scrollbar-button:start:vertical:increment {
  background:
    linear-gradient(0deg, transparent 75%, #000 0) 50%/8px 4px
    no-repeat,
    linear-gradient(0deg, transparent 50%, #000 0) 50%/6px 4px no-repeat,
    linear-gradient(0deg, transparent 25%, #000 0) 50%/4px 4px no-repeat,
    linear-gradient(0deg, #000 50%, #000 0) 50%/2px 4px no-repeat,
    #dedede;
  height: 15px;
  border-bottom: none;
}

::-webkit-scrollbar-button:start:horizontal {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
}

::-webkit-scrollbar-button:start:horizontal:decrement {
  background:
    linear-gradient(90deg, transparent 75%, #000 0) 50%/4px 8px
    no-repeat,
    linear-gradient(90deg, transparent 50%, #000 0) 50%/4px 6px no-repeat,
    linear-gradient(90deg, transparent 25%, #000 0) 50%/4px 4px no-repeat,
    linear-gradient(90deg, #000 50%, #000 0) 50%/4px 2px no-repeat,
    #dedede;
}

::-webkit-scrollbar-button:start:horizontal:increment {
  background:
    linear-gradient(270deg, transparent 75%, #000 0) 50%/4px 8px
    no-repeat,
    linear-gradient(270deg, transparent 50%, #000 0) 50%/4px 6px no-repeat,
    linear-gradient(270deg, transparent 25%, #000 0) 50%/4px 4px no-repeat,
    linear-gradient(270deg, #000 50%, #000 0) 50%/4px 2px no-repeat,
    #dedede;
  width: 15px;
  border-right: none;
}

::-webkit-scrollbar-track {
  background-color: #aaaaab;
  border: 1px solid #000;
}

::-webkit-scrollbar-track:vertical {
  box-shadow:
    inset 1px 1px 0 #787877,
    inset -1px 2px 0 #cdcccd,
    inset 2px 0 0 #888889,
    inset -2px 0 0 #bcbcbc;
}

::-webkit-scrollbar-track:horizontal {
  box-shadow:
    inset 1px 1px 0 #787877,
    inset 2px -1px 0 #cdcccd,
    inset 0 2px 0 #888889,
    inset 0 -2px 0 #bcbcbc;
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 1px 1px 0 #cdcdfc, inset -1px -1px 0 #6867c6;
  width: 14px;
  border: 1px solid #000;
}

::-webkit-scrollbar-thumb:vertical {
  background:
    linear-gradient(
      transparent 12.5%,
      #353594 0,
      #353594 25%,
      transparent 0,
      transparent 37.5%,
      #353594 0,
      #353594 50%,
      transparent 0,
      transparent 62.5%,
      #353594 0,
      #353594 75%,
      transparent 0,
      transparent 87.5%,
      #353594 0
    )
    50%/7px 8px no-repeat,
    linear-gradient(
      #cdcdfc 12.5%,
      transparent 0,
      transparent 25%,
      #cdcdfc 0,
      #cdcdfc 37.5%,
      transparent 0,
      transparent 50%,
      #cdcdfc 0,
      #cdcdfc 62.5%,
      transparent 0,
      transparent 75%,
      #cdcdfc 0,
      #cdcdfc 87.5%,
      transparent 0
    )
    49%/7px 8px no-repeat,
    #9b9bf9;
}

::-webkit-scrollbar-thumb:horizontal {
  background:
    linear-gradient(
      90deg,
      transparent 12.5%,
      #353594 0,
      #353594 25%,
      transparent 0,
      transparent 37.5%,
      #353594 0,
      #353594 50%,
      transparent 0,
      transparent 62.5%,
      #353594 0,
      #353594 75%,
      transparent 0,
      transparent 87.5%,
      #353594 0
    )
    50%/8px 7px no-repeat,
    linear-gradient(
      90deg,
      #cdcdfc 12.5%,
      transparent 0,
      transparent 25%,
      #cdcdfc 0,
      #cdcdfc 37.5%,
      transparent 0,
      transparent 50%,
      #cdcdfc 0,
      #cdcdfc 62.5%,
      transparent 0,
      transparent 75%,
      #cdcdfc 0,
      #cdcdfc 87.5%,
      transparent 0
    )
    center 49%/8px 7px no-repeat,
    #9b9bf9;
}

::-webkit-scrollbar-corner {
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  box-shadow: inset 1px 1px 0 #fff;
  background: #cdcccd;
}

*,
::before,
::after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

html,
body {
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  height: 100%;
  margin: 0;
  overflow: hidden;
  background-repeat: repeat;
  font-family: 'Charcoal', serif;
  font-size: 0.75em;
  font-weight: 100 !important;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.close-box.control-box {
  left: 4px;
}

.inner .command_button {
  height: 22px;
}

.right-button {
  float: right;
}

.content .inner {
  padding: 2px 0 4px;
  padding: 1em;
  background-color: #f3fdea;
  border: 1px solid #111;
}

.content ul {
  margin: 2px 0 1.5rem;
  padding: 0 0 0 2rem;
  font-size: 1rem;
  list-style-type: none;
}

.content {
  position: absolute;
  background: #e9f7de;
  border: 1px solid #111;
  font-size: 1rem;
  font-weight: 400;
}

.control-box {
  padding: 1px;
  position: absolute;
  top: 3px;
  z-index: 1;
  box-shadow: inset -1px -1px 0 0 #242722, inset 1px 1px 0 0 #242722;

  &:hover {
    cursor: pointer;
  }
}

.control-box-inner {
  display: block;
  height: 1rem;
  width: 1rem;
  background: #e9f6de;
  border: 1px solid #222;
  box-shadow: inset -1px 1px 0 0 #aaca92, inset 1px -1px 0 0 #637455;
  text-indent: -99999rem;
}

.hidden {
  display: none !important;
}

.hidden-window {
  height: 23px !important;
  overflow: hidden !important;
  min-width: 0;
  min-height: 0;
}

.icon {
  position: relative;
  background: none;
  outline: 0;
  border: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;

  img {
    height: 46px;
    width: 46px;
    object-fit: contain;
  }

  &:focus {
    h2 {
      background: black;
      color: white;
    }
  }

  &:hover {
    cursor: pointer;
  }
}

.titlebar {
  margin: 0;
  background-image: url('~@/assets/img/topbar.png');
  background-size: 100% 100%;
  background-position: center center;
  font-size: 1.1rem;
  padding: 2px 0;
  text-align: center;

  & ::after {
    float: right;
    position: absolute;
    right: 0;
    top: 0;
    width: 3.5rem;
  }

  &.noleft ::before {
    width: 0.5rem;
  }

  &.noright ::after {
    width: 0.5rem;
  }

  &.halfright ::after {
    width: 1.75rem;
  }

  & span {
    padding: 0 1rem;
    margin-left: -2rem;
    background-image: none;
  }

  & ::before {
    float: left;
    margin: 0;
    width: 2rem;
  }

  & ::before,
  & ::after {
    content: '\00a0';
    display: block;
    background-color: transparent;
  }
}

.visuallyhidden {
  border: 0;
  clip: rect(0000);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.window-collapse-inner {
  height: 3px;
  border-bottom: 1px solid #000;
  border-top: 1px solid #000;
  margin: 3px 1px 0;
}

.window-collapse.control-box {
  right: 4px;
}

.zoom-box-inner {
  height: 5px;
  width: 6px;
  border-bottom: 1px solid #000;
  border-right: 1px solid #000;
  margin: 1px;
}

.zoom-box.control-box {
  right: 20px;
}

#icon-holder .icon {
  clear: both;
  float: right;
  margin: 5px 0;
  position: relative;
  text-align: center;
  top: 1em;
  width: 10em;
}

#icon-holder {
  float: right;
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-wrap: wrap-reverse;
  justify-content: flex-start;
}

::-moz-focus-inner {
  border: 0;
}

:focus {
  outline: none;
}

:root {
  --button-box-shadow:
    inset -1px -1px 0 0 #777,
    inset -2px -2px 0 0 #aaa,
    inset 1px 1px 0 0 #ddd,
    inset 2px 2px 0 0 #fff;
  --button-hover-bezel: 0 0 0 1px #aaa, 0 0 0 2px #ddd, 0 0 0 3px #000;
}

::-webkit-resizer {
  margin: 3em;
}

a {
  color: #000;
}

button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;

  &[disabled] {
    opacity: 0.7;

    &:hover {
      cursor: not-allowed;
    }
  }

  &:hover {
    cursor: pointer;
  }
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 100 !important;
}

.content button {
  background-color: #dedede;
  border: 1px solid #000;
  border-radius: 3px;
  box-shadow: var(--button-box-shadow);
}

.content button:active {
  background-color: #666;
  box-shadow:
    var(--button-hover-bezel),
    inset -1px -1px 0 0 #888,
    inset -2px -2px 0 0 #777,
    inset 1px 1px 0 0 #444,
    inset 2px 2px 0 0 #555;
  color: #fff;
}

.content button:hover {
  box-shadow: var(--button-box-shadow), var(--button-hover-bezel);
}

.control-box-inner:active {
  box-shadow: none;
}

.text-italic {
  font-style: italic;
}

.ui-draggable-dragging {
  transform: scale(1);
  border: 2px black dotted !important;
  background-color: rgba(25, 25, 25, 0) !important;
}

.ui-draggable-dragging * {
  opacity: 0;
}

.ui-draggable-dragging.content,
.ui-resizable-resizing.content {
  box-shadow: none !important;
}

.ui-resizable-handle {
  background: url('~@/assets/img/corner.png');
  position: absolute;
  right: 0;
  bottom: 0;
  width: 18px;
  height: 18px;

  &:hover {
    cursor: pointer;
  }
}

div.content .inner {
  overflow-x: hidden;
  overflow-y: scroll;
}

div.content.noscroll .inner {
  overflow: hidden;
  height: 100%;
}

.text-center {
  text-align: center;
}

.modal {
  height: 100%;
  width: 100%;
  background: #000;
  z-index: 99999999;
  position: absolute !important;
  top: 0;
  left: 0;
  border-radius: 0 !important;
}

#boot-button {
  left: 50%;
  position: relative;
  top: 50%;
  height: 100px;
}

.content,
.content .inner {
  max-height: 100%;
  max-width: 100%;
  min-height: 80px;
  min-width: 100px;
  z-index: 2;
}

.alert {
  z-index: 99999998 !important;
  border: 2px #dc5341 outset;
  position: absolute;
  width: 200px;
  height: 200px;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.alert .inner {
  padding-left: 100px;
  border: none;
  box-shadow: none;
  text-align: left;
  background-repeat: no-repeat;
  background-position: 20px 10px;
  background-image: url('~@/assets/img/alert_notice.png');
}

.alert .inner p {
  margin: 0;
}

.alert-stop .inner {
  background-image: url('~@/assets/img/alert_stop.png');
}

#sadmac {
  text-align: center;
  padding: 15%;
  z-index: 99999 !important;
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
}

/** END APP.VUE MIGRATED CSS **/
.wrapper {
  height: 100%;
  width: 100%;
  display: block;
  position: relative;
  background: #89c659;
}

.desktop {
  display: block;
  height: 100%;
  width: 100%;
  padding-bottom: 30px;
}

.os-logo {
  position: relative;
  top: 1px;
}

#menu-about {
  display: flex;
  width: 75px;

  span {
    margin-left: 5px;
  }
}

#about {
  left: 20px;
  top: 30px;

  .inner {
    width: 300px;
    height: 300px;
  }
}

#lore {
  left: 30px;
  top: 40px;

  .inner {
    width: 300px;
    height: 300px;
  }
}

#claimchecker {
  left: 100px;
  top: 50px;

  .inner {
    width: 300px;
    height: 300px;
  }
}

#controls {
  .inner {
    width: 200px;
  }

  left: 70%;

  @media (max-width: 800px) {
    left: 40%;
  }

  input {
    width: 2em;
  }
}

.dialog-button {
  margin: 0 auto;
  display: block;
  margin-bottom: 10px;
}

#loggingin {
  z-index: 9000;
}

#boot,
#loggingin {
  position: relative;
  background: rgba(0, 0, 0, 0.9);

  .boot-button {
    box-shadow: inset -1px 1px 0 0 #aaca92, inset 1px -1px 0 0 #637455;
    border-radius: 1px;
    background: #e9f6de;
    border: 2px solid #ccc;
    outline: 0;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 320px;
    height: 320px;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    align-items: center;

    video {
      max-width: 70%;
      background: white;
      border: 2px solid black;
    }
  }

  .bottom-booter {
    h2 {
      font-size: 16px;
      margin-bottom: 0;
    }

    text-align: center;
  }

  .rainbow-text {
    display: inline-block;
    background: linear-gradient(to right, #f00, #ff7f00, #d0d000, #0f0, #00f, #4b0082, #9400d3);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }
}

#lookup {
  .inner {
    width: 260px;
    height: 360px;
  }
}

// same footprint as the Your RPUNKS window so the shared punk detail looks identical in both
#headshot {
  left: 60px;
  top: 50px;

  .inner {
    width: 460px;
    height: 400px;

    @media (max-width: 800px) {
      width: 300px;
    }
  }
}

#pets {
  .inner {
    width: 320px;
    height: 300px;
  }

  left: 40px;
  top: 40px;
}

.claim-pets {
  margin-top: 30px;
}

.sorry-button {
  margin: 20px 0 10px;
}

.quantity-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin: 20px 0 10px;

  input {
    margin: 5px 0 0;
    font-family: inherit;
    font-style: normal;
  }
}

.punk-number-input {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  margin: 20px 0 10px;

  input {
    margin: 10px 0;
    font-family: inherit;
    font-style: normal;
  }
}

</style>
